// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { arrForEach, arrSlice, isArray, isObject, isString, objForEachKey } from "@nevware21/ts-utils";
import { _DYN_ATTRIBUTES, _DYN_ERROR_HANDLERS } from "../__DynamicConstants";
import { createAttributeContainer } from "../otel/attribute/attributeContainer";
import { handleWarn } from "./handleErrors";
/*#__NO_SIDE_EFFECTS__*/
function _isSupportedType(theType) {
    return theType === "number" || theType === "boolean" || theType === "string";
}
/*#__NO_SIDE_EFFECTS__*/
function _isHomogeneousArray(arr) {
    var type;
    var result = true;
    arrForEach(arr, function (element) {
        // null/undefined elements are allowed
        if (element !== null) {
            var elType = typeof element;
            if (!type) {
                result = _isSupportedType(elType);
                type = elType;
            }
            else {
                result = (type === elType);
            }
        }
        if (!result) {
            return -1;
        }
    });
    return result;
}
/**
  * Helper to determine if the provided key is a valid attribute key
  * @param key - The key to check
  * @returns true if the key is a valid attribute key
  */
/*#__NO_SIDE_EFFECTS__*/
export function isAttributeKey(key) {
    return isString(key) && !!key;
}
/**
 * Helper to determine if the provided value is a valid attribute value
 * @param val - The value to check
 * @returns true if the value is a valid attribute value
 */
/*#__NO_SIDE_EFFECTS__*/
export function isAttributeValue(val) {
    var result = (val === null || _isSupportedType(typeof val));
    if (val && isArray(val)) {
        result = _isHomogeneousArray(val);
    }
    return result;
}
/**
 * Sanitize the provided attributes to ensure they conform to OTel attribute requirements
 * @param otelApi - The OpenTelemetry API instance
 * @param attributes - The attributes to sanitize
 * @returns The sanitized attributes
 */
/*#__NO_SIDE_EFFECTS__*/
export function sanitizeAttributes(otelApi, attributes) {
    var container = createAttributeContainer(otelApi.cfg);
    if (!isObject(attributes) || attributes == null) {
        return {};
    }
    objForEachKey(attributes, function (key, val) {
        if (!isAttributeKey(key)) {
            handleWarn(otelApi.cfg[_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */], "Invalid attribute key: " + key);
        }
        else if (!isAttributeValue(val)) {
            handleWarn(otelApi.cfg[_DYN_ERROR_HANDLERS /* @min:%2eerrorHandlers */], "Invalid attribute value set for : " + key);
        }
        else if (isArray(val)) {
            container.set(key, arrSlice(val));
        }
        else {
            container.set(key, val);
        }
    });
    return container[_DYN_ATTRIBUTES /* @min:%2eattributes */];
}
//# sourceMappingURL=attributeHelpers.js.map